export default "__VITE_ASSET__CULL6Jy4__"